module.exports = __webpack_public_path__ + "static/media/assessment.f66b3231.pdf";